import { render, staticRenderFns } from "./yesText.vue?vue&type=template&id=0ce76ac7"
import script from "./yesText.vue?vue&type=script&lang=js"
export * from "./yesText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports